import { Stack } from '@mui/material';
import { z } from 'zod';

import { api } from 'common';

import { PatientJobParamsFormFields, PatientJobParamsSchema } from './Common/Patients';
import { type AsynchronousJobVariant, NullableStringSchema } from './common';
import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';

import JobKind = api.RpaJob.Kind;

export const ExtractPatientInsuranceVariant: AsynchronousJobVariant = {
  schema: z.object({
    jobKind: z.literal(JobKind.ExtractUpcomingPatientInsurance),
    payload: z
      .object({
        providerFirstName: NullableStringSchema,
        providerLastName: NullableStringSchema,
      })
      .merge(PatientJobParamsSchema),
  }),
  Config: () => {
    return (
      <Stack spacing={2}>
        <PatientJobParamsFormFields />
        <BlockValueTemplateField
          fieldName="config.payload.providerFirstName"
          label="Provider First Name"
          helperText="Enter the reference to the provider's first name. e.g. `{{provider.data.firstName}}`"
          placeholder="e.g. {{provider.data.firstName}}"
        />
        <BlockValueTemplateField
          fieldName="config.payload.providerLastName"
          label="Provider Last Name"
          helperText="Enter the reference to the provider's last name. e.g. `{{provider.data.lastName}}`"
          placeholder="e.g. {{provider.data.lastName}}"
        />
      </Stack>
    );
  },
};
